module.exports = __webpack_public_path__ + "img/labels_configuration.8cd297b1.png";